import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';

import { withStyles } from '@material-ui/core/styles';

import OfferBody from './OfferBody';
import OfferHead from './OfferHead';

const OfferGrid = props => {
  const { classes, columns, data, strings } = props;
  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <OfferHead columns={columns} strings={strings} />
        <OfferBody columns={columns} data={data} strings={strings} />
      </Table>
    </Paper>
  );
};

OfferGrid.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  strings: PropTypes.object.isRequired, // eslint-disable-line
};

OfferGrid.defaultProps = {
  data: [],
  columns: [],
};

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 300,
  },
});

export default withStyles(styles)(OfferGrid);
